export default __webpack_public_path__ + "static/media/4.28d694f8.png";